import React, { Component } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import { Document, Page } from 'react-pdf';

class PdfViewModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numPages: null,
    };
  }

  render() {
    console.log("data111111111111", this.props.stateData?.pdfData[0]?.file_path);
    return (
      <Modal {...this.props} size="lg"  aria-labelledby="example-modal-sizes-title-lg">
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">View Pdf</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4" style={{
          width: '100%',
          height: '600px',
          overflow: 'auto',
        }}>
          <Row>
            <Col sm={12}>
              <Document
                file={this.props.stateData?.pdfData[0]?.file_path}
                onLoadSuccess={({ numPages }) => this.setState({ numPages })}
              >
                {Array.from(new Array(this.state.numPages), (el, index) => (
                  <Page key={`page_${index + 1}`} pageNumber={index + 1} width={700} />
                ))}
              </Document>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    );
  }
}

export default PdfViewModal;
